import { PAGE_SIZE } from '@/constants'
import { PetdaysApi } from './tempApi'
import fetcher from '@/services/fetcher'
import { buildQuery, buildQueryV2 } from '@/utils/helpers'
import { ICustomAttributeMetadata } from '../types'
import appConfig from '@/config/global-config'

interface IOptionsProductProps {
  filter?: Record<string, any>
  pageSize?: number
  currentPage?: number
  search?: string
  sort?: Record<string, any>
  rating_stars?: number // Thêm filter theo số sao đánh giá
}

export const fetchProducts = async (params: IOptionsProductProps, options?: { locale?: string }) => {
  const { filter = {}, pageSize = PAGE_SIZE, currentPage = 1, search = '', sort = {} } = params
  try {
    const response = await fetcher.get(
      buildQuery(PetdaysApi.products, {
        filter,
        pageSize,
        currentPage,
        search,
        sort,
      }),
      {
        next: { revalidate: 300, tags: [`${JSON.stringify(params)}`] },
        cache: 'force-cache',
        locale: options?.locale || appConfig.defaultLocale,
      }
    )
    const products = response?.payload?.data?.products as IProducts
    return products
  } catch (err) {
    console.log(err)
    return undefined
  }
}

export const fetchAsideAggregations = async (params: IOptionsProductProps, options?: { locale?: string }) => {
  const { filter = {}, pageSize = 12, currentPage = 1, search = '', sort = {} } = params
  try {
    const response = await fetcher.get(
      buildQueryV2(PetdaysApi.aside, {
        filter,
        pageSize,
        currentPage,
        search,
        sort,
      }),
      {
        next: { revalidate: 300, tags: [`aside-${JSON.stringify(params)}`] },
        cache: 'force-cache',
        locale: options?.locale,
      }
    )
    const products = response?.payload?.data?.products as IProducts
    return { ...products, isLoading: false }
  } catch (err) {
    console.log(err)
    return null
    // throw err
  }
}

export const fetchAsideCategories = async (options?: { locale?: string }) => {
  try {
    const response = await fetcher.get(
      buildQueryV2(PetdaysApi.asideCategories, {
        filters: {},
      }),
      {
        next: { revalidate: 300, tags: ['header-category-list-pet'] },
        cache: 'force-cache',
        locale: options?.locale,
      }
    )
    const categories = response?.payload?.data?.categories as ICategories
    return categories
  } catch (err) {
    console.log(err)
    return undefined
  }
}

export const fetchDetailProduct = async (url_key: string, options?: { locale?: string }) => {
  try {
    const response = await fetcher.get(
      buildQueryV2(PetdaysApi.detail_products, {
        url: url_key,
      }),
      {
        next: {
          revalidate: 300,
          tags: [url_key],
        },
        cache: 'force-cache',
        locale: options?.locale,
      }
    )
    return response?.payload?.data?.route as Product
  } catch (err) {
    console.log(err)
    return undefined
  }
}

export const GET_CUSTOM_ATTRIBUTE_METADATA = `
query customAttributeMetadata($attributes: [AttributeInput!]!) {
  customAttributeMetadata(attributes: $attributes) {
    items {
      attribute_code
      attribute_options {
        label
        value
      }
      attribute_type
      entity_type
      input_type
      storefront_properties {
        position
        use_in_layered_navigation
        use_in_product_listing
        use_in_search_results_layered_navigation
        visible_on_catalog_pages
      }
    }
  }
}
`
export const fetchCustomAttributeMetadata = async ({ attributes, locale }: any) => {
  try {
    const response = await fetcher.get(
      buildQuery(GET_CUSTOM_ATTRIBUTE_METADATA, {
        attributes,
      }),
      {
        next: { revalidate: 300, tags: ['custom-attribute-metadata'] },
        cache: 'force-cache',
        locale: locale,
      }
    )
    return response?.payload?.data?.customAttributeMetadata?.items as ICustomAttributeMetadata[]
  } catch (err) {
    console.log(err)
    return []
  }
}
